import axios from "./index";

class Routes {
  getContacts() {
    return axios.get(`/contact/get-contact`);
  }
  setComplete(id) {
    return axios.post(`/contact/contactComplete/${id}`);
  }
}

export default new Routes();
